var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error500"},[_c('error',{attrs:{"code":500,"title":"哎呀，出错了！系统错误，请稍后再试…"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }